const env = {
  API_URL: process.env.REACT_APP_API_URL,
  API_KEY: process.env.REACT_APP_X_API_KEY,
};

export default env;
